import { render } from "./TaxSettingsCard.vue?vue&type=template&id=78a7c9a8"
import script from "./TaxSettingsCard.vue?vue&type=script&lang=js"
export * from "./TaxSettingsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__